import ConfirmationDialog from 'components/Common/ConfirmationDialog';
import React, {
  createContext, useContext, useState,
} from 'react';
import { FlowContext } from 'pages/Flow/FlowContextProvider';
import { useDeleteFlow } from 'api/flows';
import { useFlowDeletionMessage } from 'pages/Flow/useFlowDeletionMessage';


export const DeleteFlowListContext = createContext({});

export const DeleteFlowListContextProvider = ({ children }) => {
  const { mutateAsync } = useDeleteFlow();
  const {
    dataContextRef,
  } = useContext(FlowContext);

  const [deleteFlowDescription, setDeleteFlowDescription] = useState(null);

  const { confirmationMessage, isLoadingImpact } = useFlowDeletionMessage(deleteFlowDescription);

  const handleOnCancel = () => {
    setDeleteFlowDescription(null);
  };

  const handleOnConfirm = async () => {
    await mutateAsync({ flowId: deleteFlowDescription.ID, crId: deleteFlowDescription.crID });
    dataContextRef.current.refreshListData();
    handleOnCancel();
  };

  const deleteFlowListContextValue = {
    setDeleteFlowDescription,
  };

  return (
    <DeleteFlowListContext.Provider value={deleteFlowListContextValue}>
      {children}
      {deleteFlowDescription && (
        <ConfirmationDialog
          open={Boolean(deleteFlowDescription)}
          title='Delete Flow?'
          message={confirmationMessage}
          loading={isLoadingImpact}
          confirmActionLabel='Delete'
          onConfirm={handleOnConfirm}
          onCancel={handleOnCancel}
        />
      )}
    </DeleteFlowListContext.Provider>
  );
};
